// extracted by mini-css-extract-plugin
export default {"tableOfContents":"tableOfContents_TN1Q","docItemContainer":"docItemContainer_JtJJ"};